import { Pipe, PipeTransform } from '@angular/core';
import {LorenUserInfo} from '../../../shared/interfaces/loren-user-info.interface';

@Pipe({
    name: 'lorenUserFilter',
    standalone: false
})
export class LorenUserFilterPipe implements PipeTransform {

  transform(users: Partial<LorenUserInfo>[], filterValue: string): Partial<LorenUserInfo>[] {
    return users.filter(user => `${user.firstName}${user.lastName}`.toLowerCase().includes(filterValue.toLowerCase()));
  }

}
